<div class="irembogov-configuration-form-builder mt-2 w-100">
  <div class="w-100">
    <div #errorMessageElement class="px-5">
      <irembogov-irembo-section-message
        *ngIf="showConfigFormErrorMessage"
        [type]="formAlertContent.type"
        [title]="formAlertContent.title"
        [message]="formAlertContent.message"
        [extraMessage]="formAlertContent.extraMessage"
        [extraMessageAsHtml]="true"></irembogov-irembo-section-message>
    </div>
  </div>
  <!-- V1 Classic Builder Layout -->
  <div class="w-100 d-flex p-3" *ngIf="!useV2Builder">
    <div class="flex-grow-1 me-3 preview-section-wrapper">
      <div class="preview-section">
        <div class="mb-3">
          <div class="preview-box">
            <div
              class="preview-box-invalid"
              *ngIf="this.jsonEditorValidationErrors.length > 0">
              Invalid Json Object in Code Editor
            </div>
            <div class="preview-box-view">
              <irembogov-preview-service-change-request-json-formdata-widget
                [showHiddenAndHideFieldControls]="
                  true
                "></irembogov-preview-service-change-request-json-formdata-widget>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="justify-self w-40 side-pane-wrapper">
      <irembogov-service-change-request-feedback-handler-widget
        *ngIf="changeRequest"
        (selectOptionChanged)="onTabSelectChanged($event)"
        [changeRequestId]="changeRequest.id ?? ''"
        [serviceChangeRequestSection]="EServiceChangeRequestSection.FORM"
        [selectedOption]="EServiceChangeRequestToggleHeaders.WIZARD">
        <div wizard>
          <irembogov-form-field-configurator></irembogov-form-field-configurator>
        </div>
        <div codeEditor>
          <ng-container *ngTemplateOutlet="codeEditorTemplate"></ng-container>
        </div>
      </irembogov-service-change-request-feedback-handler-widget>
      <ng-container *ngTemplateOutlet="saveBarTemplate"></ng-container>
    </div>
  </div>

  <!-- V2 New Builder Layout with Resizable Sidebar -->
  <div class="w-100 p-3" *ngIf="useV2Builder">
    <irembogov-fb-resizable-layout>
      <irembogov-fb-v2-canvas canvas></irembogov-fb-v2-canvas>
      <div sidebar class="h-100 fb-v2-sidebar">
        <div class="fb-v2-sidebar__scroll">
          <irembogov-service-change-request-feedback-handler-widget
            *ngIf="changeRequest"
            (selectOptionChanged)="onTabSelectChanged($event)"
            [changeRequestId]="changeRequest.id ?? ''"
            [serviceChangeRequestSection]="EServiceChangeRequestSection.FORM"
            [selectedOption]="EServiceChangeRequestToggleHeaders.WIZARD">
            <div wizard>
              <irembogov-fb-field-properties-panel></irembogov-fb-field-properties-panel>
            </div>
            <div codeEditor>
              <div class="d-flex justify-content-end mb-2">
                <button
                  class="btn btn-sm fb-fullscreen-open-btn"
                  (click)="openFullscreenEditor()">
                  <i class="fa-solid fa-expand"></i> Full Screen
                </button>
              </div>
              <ng-container
                *ngTemplateOutlet="codeEditorTemplate"></ng-container>
            </div>
          </irembogov-service-change-request-feedback-handler-widget>
        </div>
      </div>
    </irembogov-fb-resizable-layout>
    <!-- Continue is decoupled from the builder: its own action bar below the
         layout, with breathing room from the bottom (matches other steps). -->
    <div class="fb-v2-actions">
      <ng-container *ngTemplateOutlet="saveBarTemplate"></ng-container>
    </div>
  </div>

  <!-- Shared Templates -->
  <ng-template #codeEditorTemplate>
    <div class="code-editor-section">
      <div class="mb-3">
        <div class="form-group">
          <div class="input-group mb-3">
            <json-editor
              [options]="editorOptions"
              id="jsonFormData"
              class="form-control p-0 json-form-data-field"
              (change)="validateJsonEditor()"
              inputMode="code"
              [data]="
                jsonEditorFormData ? jsonEditorFormData : DefaultEmptyFormData
              "
              #jsonFormData>
            </json-editor>
          </div>
          <div
            class="form-error w-100 small text-danger"
            *ngIf="jsonEditorValidationErrors.length > 0">
            JSON input is invalid
            <ol>
              <li
                class="w-100 small"
                *ngFor="
                  let error of jsonEditorValidationErrors;
                  let index = index
                ">
                <em class="text-muted"> Line {{ error['line'] }}</em>
                <br />
                <small [innerHTML]="error['message']"></small>
              </li>
            </ol>
          </div>
          <div
            class="form-error w-100 small text-danger"
            *ngIf="!jsonEditorFormData">
            Please enter a JSON Form entry
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #saveBarTemplate>
    <div class="px-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="small text-muted" *ngIf="autoSaveInProgress">
          <div
            class="spinner-border spinner-border-sm mr-1"
            role="status"
            style="width: 0.8rem; height: 0.8rem"></div>
          <span>Autosaving...</span>
        </div>
        <div
          class="small text-muted"
          *ngIf="lastAutoSaved && !autoSaveInProgress">
          <span>Last saved: {{ lastAutoSaved | date : 'medium' }}</span>
        </div>
        <div class="text-end">
          <button
            (click)="onFormSubmit()"
            class="btn btn-primary mt-1 px-5"
            type="button"
            [disabled]="
              isLoading ||
              jsonEditorValidationErrors.length > 0 ||
              !jsonEditorFormData
            ">
            <div
              *ngIf="isLoading"
              class="spinner-border spinner-border-sm mr-2"
              role="status"></div>
            Continue
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <irembogov-fb-fullscreen-editor
    *ngIf="showFullscreenEditor"
    (closed)="closeFullscreenEditor()">
  </irembogov-fb-fullscreen-editor>
</div>
